(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dhb-editorial"] && !Shopify.designMode) return;
  try {
    
function initDhbPicks(root=document){root.querySelectorAll('[data-dhb-picks]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const cards=[...box.querySelectorAll('.dhb-pick')],pages=box.querySelector('[data-pick-pages]'),count=Math.ceil(cards.length/8);let current=0;function show(n){current=Math.max(0,Math.min(count-1,n));cards.forEach((card,i)=>card.hidden=i<current*8||i>=(current+1)*8);pages.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-current',String(i===current)));box.querySelector('[data-step="-1"]').disabled=current===0;box.querySelector('[data-step="1"]').disabled=current===count-1;box.querySelector('[data-pick-status]').textContent='Product set '+(current+1)+' of '+count;}for(let i=0;i<count;i++){const button=document.createElement('button');button.type='button';button.textContent=i+1;button.setAttribute('aria-label','Product set '+(i+1));button.addEventListener('click',()=>show(i));pages.append(button);}box.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>show(current+Number(button.dataset.step))));show(0);});}initDhbPicks();document.addEventListener('shopify:section:load',event=>initDhbPicks(event.target));
function openDhbGuide(){if(!/^#dhb-guide-(rugs|curtains|mats)$/.test(location.hash))return;const guide=document.querySelector(location.hash);if(guide){guide.open=true;guide.scrollIntoView({block:'center'});}}openDhbGuide();window.addEventListener('hashchange',openDhbGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
